module.exports = "<p>This widget does not have any options. Press save to create the widget.</p>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/modals/dashboard/modify_widgets/genericnooptions/genericnooptions.html
// module id = 911
// module chunks = 7